import { DEFAULT_THEME, MantineThemeOverride } from '@mantine/core';
import { getMainTheme } from 'lib/themes/theme';
import { useMoonChainKeyParam } from './useMoonChainParam';

export function useMainTheme(): MantineThemeOverride {
  const moonChainKey = useMoonChainKeyParam();

  return getMainTheme(DEFAULT_THEME, moonChainKey);
}
